import React from "react";
import { Link } from "react-router-dom";
import organicPdf from "../../data/Organic Products Catelogue.pdf";
import "./MegaMenu.css";

const MegaMenu = ({ closeMobileMenu }) => {
  return (
    
        <div className="mega-menu">
      <div className="mega-column">
        {/* <Link to="/organic-products-pdf" onClick={closeMobileMenu}>Organic Products</Link> */}
        <Link to="/products?category=Value Add Products" onClick={closeMobileMenu}>Value Added Products</Link>
        <Link to="#" onClick={(e) => (e.preventDefault(), window.open(organicPdf, "_blank", "noopener,noreferrer"), closeMobileMenu())}>Organic Products</Link>
        <Link to="/products?category=eco_friendly" onClick={closeMobileMenu}>Eco - Friendly</Link>
      </div>

      <div className="mega-column">
        <Link to="/products?category=Millets Cereals Pulses" >Millets Cereals Pulses</Link>
        <Link to="/products?category=spices"  onClick={closeMobileMenu}>Spices</Link>
        {/* <Link to="/products?category=Agro Products"  onClick={closeMobileMenu}>Agro Products</Link> */}
      </div>

      <div className="mega-column">
        <Link to="/products?category=Fresh Vegetables"  onClick={closeMobileMenu}>Fresh Vegetables</Link>
        <Link to="/products?category=Handicrafts"  onClick={closeMobileMenu}>Handicrafts</Link>
        {/* <Link to="/products?category=Apparels"  onClick={closeMobileMenu}>Apparels</Link> */}
      </div>
    </div>
  );
};

export default MegaMenu;